export default __webpack_public_path__ + "images/price-icon_3.svg?9ebc6558840d9800d577ee6d77660550";